import { CSSProperties, ReactNode } from "react";
import { IBtnList } from "../ButtonGroup/buttonGroup";
import { CommonlyType } from "../SuperTable/interface";

export interface MenuTreeProps {
  /** 选择回调 */
  onSelect?: (value: string, label: any, parentKey?: string) => void;
  /** 展开、关闭回调 */
  onOpen?: (isOpen: boolean, value: string, label: any) => void;
  /** 展开-收起时的回调函数 */
  onCollapse?: (collapsed: boolean) => void;
  /** 默认展开组 */
  defaultOpenSubMenus?: string[];
  /** 展开组 */
  openSubMenus?: string[];
  /** 默认选中项 */
  defaultSelectedKey?: string;
  /** 选中项 */
  selectedKey?: string;
  /** 默认展开全部 */
  defaultOpenSubMenusAll?: boolean;
  /** 是否显示边框 */
  border?: boolean;
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 是否隐藏title提示 */
  hideTitle?: boolean;
  /** 是否开启动画（三级或三级以上的菜单，该属性必须的值需设置为false） */
  animation?: boolean;
  /** 分组节点是否可以选中 */
  isSelectSubMenu?: boolean;
  /** 是否可收起 */
  collapsible?: boolean;
  /** 是否收起*/
  collapsed?: boolean;
  /** 底部额外高度 */
  bottomHeight?: number;
  /** 子节点 */
  children?: ReactNode;
}

export interface SubMenuProps {
  /** 唯一标识 */
  value: string;
  /** 组标题 */
  label: ReactNode;
  /** 副标题 */
  subLabel?: ReactNode;
  /** title提示内容 */
  titleTtooltip?: string | false;
  /** 图标 */
  icon?: ReactNode;
  /** 后置标签 */
  addonAfter?: ReactNode;
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 没有数据是展示 */
  noData?: ReactNode;
  /** 唯一标识 */
  index?: string;
  /** 父标识 */
  parentIndex?: string;
  /** 层级 */
  level?: number;
  /** 操作按钮组 */
  operation?: CommonlyType[] | IBtnList[] | false;
  /** 操作按钮组 */
  itemOperation?: CommonlyType[] | IBtnList[] | false;
  /** 是否收缩 */
  collapsed?: boolean;
  children?: any;
  /** 点击后置标签 */
  onClickAddonAfter?: () => void;
  /** 点击操作按钮组 */
  onClickOperation?: (operationKey: string, itemKey: string, label: any, parentKey?: string) => void;
  /** 点击item操作按钮组 */
  onClickItemOperation?: (operationKey: string, itemKey: string, label: any, parentKey?: string) => void;
}

export interface MenuItemProps {
  /** 唯一标识 */
  value: string;
  /** item文本 */
  label?: ReactNode;
  /** 副标题 */
  subLabel?: ReactNode;
  /** title提示内容 */
  titleTtooltip?: string | false;
  /** 前置图标 */
  icon?: ReactNode;
  /** 是否禁用 */
  disabled?: boolean;
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 唯一标识 */
  index?: string;
  /** 父标识 */
  parentIndex?: string;
  /** 操作按钮组 */
  operation?: CommonlyType[] | IBtnList[] | false;
  /** 层级 */
  level?: number;
  /** 子节点 */
  children?: ReactNode;
  /** 是否收缩 */
  collapsed?: boolean;
  /** 点击操作按钮组 */
  onClickOperation?: (operationKey: string, itemKey: string, label: any, parentKey?: string) => void;
}

export enum MenuTreeChildrenEnum {
  SubMenu = 'SubMenu',
  MenuItem = 'MenuItem',
};